import React from "react";
import SEO from "../components/seo";
import Layout from "../components/layout";
import PageSectionContainer from "../components/common/page-section-container";
import PageSectionHeading from "../components/common/page-section-heading";
import NewsletterSubscriptionForm from "../components/common/newsletter-subscription-form";
var NewsletterPage = function NewsletterPage() {
    return /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(SEO, {
        title: "Newsletter Anmeldung"
    }), /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap justify-center"
    }, /*#__PURE__*/ React.createElement(PageSectionContainer, {
        className: "w-full border-t-8 border-solid border-makroOrange lg:w-2/3"
    }, /*#__PURE__*/ React.createElement(PageSectionHeading, {
        title: "Newsletter Anmeldung"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "mt-2 mb-8"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mb-2"
    }, "Sie erhalten unseren Newsletter zweimal pro Woche."), /*#__PURE__*/ React.createElement(NewsletterSubscriptionForm, null))))));
};
export default NewsletterPage;
